import { useMemo } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import useUnlinked from "./useUnlinked";

/**
 * The layout route around every /investing page. It hands the shell's
 * outlet context (`me`, `meLoading`, …) straight through, and wraps the
 * pages in `[data-investing]`: inside it the light theme's muted text is a
 * step darker, so it reads AA on the page background (tailwind.css). The
 * dialogs the pages portal out carry the same attribute themselves.
 *
 * It adds `unlinked` (useUnlinked): the tasks and discussions made for a
 * company whose link failed, one store for every page — the Research list
 * and a company's page offer the same "Link task #N".
 *
 * No humans-only gate here: an agent may read Research (spec §5). The
 * person-only controls gate themselves, failing closed while `me` is
 * unknown.
 */
function InvestingLayout() {
  const shell = useOutletContext();
  const unlinked = useUnlinked(shell?.me?.id);
  const context = useMemo(() => ({ ...shell, unlinked }), [shell, unlinked]);
  return (
    <div data-investing="">
      <Outlet context={context} />
    </div>
  );
}

export default InvestingLayout;
